<template>
  <div class="tree-node-wrapper" :class="getLevelClass">
    <!-- Horizontal line connecting to the main vertical line (for all child levels) -->
    <!-- <div class="tree-horizontal-line"></div> -->

    <div
      :class="[
        'test-container flex items-center justify-between mt-1',
        { 'filtered-test-highlight': (filteredTest && testNode.id === filteredTest.id) },
        { 'not-allowed-select': testNode.value[isNotAllowedSelectProp] },
        fontClassList[fontClassIndex],
        { 'not-allowed-current-menu-color': !isAllowedSelect || testNode.value[isNotAllowedSelectProp] },
        !testNode.value[this.selectProp] &&
          (addOnRequiredMoreNoOfTubesTests.map(i => i.id).includes(testNode.id) ||
          addOnExpiredTestList.includes(testNode.id)) || addOnFixedVaVwTestWithParents.has(testNode.id) ||
          addOnDesendantList.includes(this.testNode.id)
          ? 'add-on-require-more-tube' : '',
      ]"
      @click.stop="handleClickTest(testNode.value)"
    >
      <div class="flex items-center">
        <img 
          :src="prefix[prefixStyle]" 
          alt="prefix" 
          :class="[
            'prefix', 
            { 'not-allowed-prefix': testNode.value[isNotAllowedSelectProp] || !isAllowedSelect }
          ]"
        >
        <span class="flex items-center" style="gap: 6px;">
          <p :class="fontClassIndex === fontClassList.length-1 ? 'ml-7' : 'ml-3' ">
            {{ getItemNameByLanguage(testNode.value) }}
          </p>
          <!-- Info Icon with Tooltip -->
          <TestInfoIconPopover 
            v-if="testNode.value.infoIcon"
            :info-text="testNode.value.infoIcon"
          />
        </span>
      </div>
      <div
        class="flex items-center tag-price-wrap"
        @click.stop="handleClickTest(testNode.value)"
      >
        <!-- Sample Type Tags + price (loop all tags) - only for new VW beta, clickable to toggle selection -->
        <template v-if="!shouldHideSampleTypeTags">
          <TestSampleTypeTagNew
            v-for="t in sampleTypeTagInfo.keys"
            :key="t"
            :type="sampleTypeTagType(t)"
          />
        </template>
        <span v-if="displayPrice" class="sample-price">{{ displayPrice }}</span>
        <a 
          v-if="testNode.value.weblink" 
          :href="testNode.value.weblink" 
          target="_blank" 
          class="ml-1"
        >
          <span class="material-icons-outlined insert-link-icon">
            insert_link
          </span>
        </a>
      </div>
    </div>

    <!-- Children container -->
    <div v-if="hasDescendants" class="children-container">
      <TreeNodeTest
      v-for="node in testNode.descendants" 
      :key="node.id"
      :test-node="node"
      :filtered-test="filteredTest"
      :font-class-index="fontClassIndex + 1"
      :select-prop="selectProp"
      :is-not-allowed-select-prop="isNotAllowedSelectProp"
      :order-test-support-obj="orderTestSupportObj"   
      :prefix="prefix"
      :addOnDesendantList="addOnFixedVaVwTest.has(testNode.id)
        ? addOnDesendantList.concat(addOnFixedVaVwTest.get(testNode.id))
        : addOnDesendantList"
    />
    </div>
    <ItemNotAllowedDialog 
      v-if="isShowTestNotAllowedDialog"
      :is-show-dialog="isShowTestNotAllowedDialog"
      :item-category="testNode.value.category"
      :item-name="testNode.value.testName"
      :dialog-type="!isAllowedForPatientAge ? 'notAllowedForPatientAge' : 'notAllowedForMenu'"
      @close="isShowTestNotAllowedDialog = false"
    />
    <AddOnUnableSelectDialog 
      :is-show-dialog="addOnUnableSelectDialogVisible" 
      :test-name="testNode.value.testName" 
      :unable-select-reason="addOnUnableSelectReason" 
      :add-on-remaining-stability-days="addOnRemainingStabilityDays"
      @addTestAnyway="handleAddTestAnyway"
      @close="addOnUnableSelectDialogVisible = false"
    />
  </div>
  
</template>

<script>
import ItemNotAllowedDialog from "../../ItemNotAllowedDialog.vue";
import { addSelectedTest, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection.js";
import AddOnUnableSelectDialog from './AddOnUnableSelectDialog.vue'
import TestInfoIconPopover from "../../../components/TestInfoIconPopover.vue";
import { isItemAllowedForCurrentMenu, isItemAllowedForPatientAge } from "../../custom-panel/customPanelCard.js";
import { getTestCardPrefix, getItemNameByLanguage } from "./testCard.js";
import { mapGetters, mapState } from 'vuex';
import TestSampleTypeTagNew from "../../../components/TestSampleTypeTagNew.vue";
import { getSampleTypeSetsNew, getSampleTypeTagInfoFromSetsNew } from "@/utils/va-order-test/sampleTypes.js";
import { processNameAbbreviationNew } from "@/utils/va-order-test/index.js";
import { BLOOD_SALIVA_ADDON_IDS } from "@/utils/va-order-test/testAndPanelSelection/geneticAddonConstants.js";
export default {
  name: "TreeNodeTest",
  components: {
    AddOnUnableSelectDialog,
    ItemNotAllowedDialog,
    TestInfoIconPopover,
    TestSampleTypeTagNew,
  },
  props: {
    testNode: {
      type: Object,
      default: () => {}
    },
    filteredTest: {
      type: Object,
      default: () => {}
    },
    fontClassIndex: {
      type: Number,
      default: 0
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    },
    prefix: {
      type: Object,
      default: () => {}
    },
    addOnDesendantList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      // different design for each layer of tests in va or vw trees
      fontClassList: ["test-group-title-lg", "test-group-title-sm", "single-test-text"],
      isShowTestNotAllowedDialog: false,
      addOnUnableSelectDialogVisible: false,
      addOnUnableSelectReason: "Already Ordered",
      addOnRemainingStabilityDays: 1
    }
  },

  computed: {
    ...mapState(["language"]),
    ...mapState("orderTest", [
      "addOnFixedVaVwTest",
      "addOnFixedVaVwTestWithParents",
      "isAddOnOrder",
      "isDbsVersion",
      "addOnRequiredMoreNoOfTubesTests", 
      "addOnExpiredTestList",
      "addOnExpiredSoonAddonTests",
    ]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapGetters("orderTest/order", ["patientAge"]),
    prefixStyle() {
      return getTestCardPrefix(this.testNode, this.testNode.descendants, this.selectProp);
    },
    // Price shown after tags: prefer total, fallback to price
    // VA: keep 2 decimals; VW: integer only
    displayPrice() {
      try {
        const v = this.testNode?.value || {};
        const price = (v.total ?? v.price);
        if (price === undefined || price === null) return "";
        const symbol = this.$store.state.currency?.symbol || "$";
        const decimals = v.category === "vw" ? 0 : 2;
        return `${symbol}${Number(price).toFixed(decimals)}`;
      } catch (e) {
        return "";
      }
    },

    sampleTypeTagInfo() {
      try {
        const setsNew = getSampleTypeSetsNew(this.testNode?.value || {});
        return getSampleTypeTagInfoFromSetsNew(setsNew);
      } catch (e) {
        return { keys: [], single: "" };
      }
    },
    singleSampleTypeTagKey() {
      return this.sampleTypeTagInfo.single;
    },

    isAllowedSelect() {
      return isItemAllowedForCurrentMenu(this.isDbsVersion, this.testNode.value)
         && this.isAllowedForPatientAge;
    },

    isAllowedForPatientAge() {
      return isItemAllowedForPatientAge(this.testNode.value, this.orderTestSupportObj, this.patientAge);
    },

    shouldHideSampleTypeTags() {
      // Hide sample type tags for genetic addons when they are not allowed to select
      // exception: if menu is DBS version, then no need to hide sample type tags
      // because only saliva addons are available in DBS version
      if (this.isDbsVersion) {
        return false;
      }
      const testId = this.testNode.id;
      const isGeneticAddon = Object.values(BLOOD_SALIVA_ADDON_IDS).some(
        ({ blood, saliva }) => blood === testId || saliva === testId
      );
      return isGeneticAddon && this.testNode.value[this.isNotAllowedSelectProp] === true;
    },

    // Get level class for styling (0-2)
    getLevelClass() {
      const level = Math.min(this.fontClassIndex, 2);
      return `level-${level}`;
    },

    // Check if node has descendants
    hasDescendants() {
      return this.testNode.descendants && this.testNode.descendants.length > 0;
    },
  },

  methods: {
    sampleTypeTagType(type) {
      if (this.selectProp === "isSelectForShortcut") {
        return processNameAbbreviationNew(type);
      }
      return type;
    },

    // select or de-select test
    handleClickTest(test) {
      if (!this.isAllowedSelect) {
        this.isShowTestNotAllowedDialog = true;
        return;
      }
      if((this.addOnDesendantList && this.addOnDesendantList.includes(this.testNode.id)) || this.addOnFixedVaVwTest.has(this.testNode.id)) {
        this.addOnUnableSelectDialogVisible = true
        this.addOnUnableSelectReason = "Already Ordered"
        return
      }

      if(this.addOnRequiredMoreNoOfTubesTests.map(i => i.id).includes(this.testNode.id)) {
        this.addOnUnableSelectDialogVisible = true
        this.addOnUnableSelectReason = "Requires New Kit"
        return
      }

      if(this.addOnExpiredTestList.includes(this.testNode.id)) {
        this.addOnUnableSelectDialogVisible = true
        this.addOnUnableSelectReason = "Expired"
        return
      }

      if(this.addOnExpiredSoonAddonTests.has(this.testNode.id) && !test[this.selectProp]) {
        this.addOnUnableSelectDialogVisible = true
        this.addOnUnableSelectReason = "Might Expire Soon"
        this.addOnRemainingStabilityDays = this.addOnExpiredSoonAddonTests.get(this.testNode.id)
        return
      }

      test[this.selectProp] 
        ? removeSelectedTest(test.id, this.selectProp, this.orderTestSupportObj)
        : addSelectedTest(test.id, this.selectProp, this.orderTestSupportObj);
      
      // add back removed add on va vw tests
      if(this.isAddOnOrder&&this.addOnFixedVaVwTestWithParents.has(test.id)) {
        this.addOnFixedVaVwTestWithParents.get(test.id).forEach(i => {
          addSelectedTest(i, this.selectProp, this.orderTestSupportObj);
        })
      }

      this.isAddOnOrder.length > 0 && this.$store.dispatch("orderTest/addOnFixedVaVwTestTubeInfo", {root:test,isFixedVaVw:'false',isSelect:test[this.selectProp] ? 'true' : 'false'}) 
    },
    handleAddTestAnyway() {
      addSelectedTest(this.testNode.id, this.selectProp, this.orderTestSupportObj);
      this.isAddOnOrder.length > 0 && this.$store.dispatch("orderTest/addOnFixedVaVwTestTubeInfo", {root:this.testNode.value,isFixedVaVw:'false',isSelect:this.testNode.value[this.selectProp] ? 'true' : 'false'}) 
    },
    getItemNameByLanguage(item) {
      return getItemNameByLanguage(item, this.language);
    }
  },
}
</script>

<style scoped>
.test-container {
  background: #FFFFFF;
  font-weight: normal;
  font-size: 13px;
  line-height: 29px;
  letter-spacing: 0.15px;
  color: #000000;
  min-height: 25px;
}

.filtered-test-highlight {
  border: 1px solid #3498DB;
}

.not-allowed-select {
  pointer-events: none;
}

.not-allowed-prefix {
  opacity: 0.4;
}

.prefix {
  width: 18px;
  height: 18px;
}

.test-group-title-lg {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.15px;
  color: #000000;
  background: #ECF3FC;
}

.test-group-title-sm {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0.15px;
  color: #000000;
}

.single-test-text {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0.15px;
  color: #4A4A4A;
}

.insert-link-icon {
  color: #3498DB;
  font-size: 16px;
  line-height: normal;
}

.add-on-require-more-tube {
  background-color: #F2F2F2;
  /* text-decoration: line-through; */
}

.not-allowed-current-menu-bg {
  background: #F2F2F2;
}

.not-allowed-current-menu-color {
  color: #979797;
}

.sample-price {
color: var(--TrueBlack, #333);
font-feature-settings: 'liga' off, 'clig' off;
font-family: Inter;
font-size: 15px;
font-style: normal;
font-weight: 400;
line-height: 18px; /* 120% */
letter-spacing: 0.15px;
padding-right: 24px;
white-space: nowrap;
min-width: 72px;
text-align: right;
}
/* Ensure consistent spacing between tags and price */
.tag-price-wrap {
  gap: 8px;
}

/* ========================
   New Tree Design Styles
   ======================== */
.tree-node-wrapper {
  position: relative;
}

/* Horizontal line connecting to main vertical line */
/* .tree-horizontal-line {
  position: absolute;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 1px;
  background: #CBD5E1;
  z-index: 1;
} */

/* Children container */
.children-container {
  position: relative;
  padding-left: 20px;
  margin-top: 4px;
}

/* Adjust container styling for new design */
.test-container {
  background: #F9FBFD !important;
  border-radius: 6px;
  padding: 4px 0px;
  min-height: 28px;
  transition: all 0.2s ease;
  box-shadow: none;
}

/* Override fontClass background styles */
.test-container.test-group-title-lg,
.test-container.test-group-title-sm,
.test-container.single-test-text {
  background: #F9FBFD !important;
}

.test-container:hover {
  box-shadow: none;
}

/* ========================
   Checkbox colors by level
   ======================== */
/* Level 0 (second level) - #5587BC */
.tree-node-wrapper.level-0 .prefix {
  filter: brightness(0) saturate(100%) invert(50%) sepia(41%) saturate(1956%) hue-rotate(190deg) brightness(92%) contrast(57%) !important;
}

/* Level 1 (third level) - #20A7C1 */
.tree-node-wrapper.level-1 .prefix {
  filter: brightness(0) saturate(100%) invert(27%) sepia(67%) saturate(8378%) hue-rotate(178deg) brightness(146%) contrast(75%) !important;
}

/* Level 2 (fourth level+) - #20A7C1 */
.tree-node-wrapper.level-2 .prefix {
  filter: brightness(0) saturate(100%) invert(27%) sepia(67%) saturate(8378%) hue-rotate(178deg) brightness(146%) contrast(75%) !important;
}

</style>